module.exports = __webpack_public_path__ + "assets/img/shop_detail_img5.67920c95.png";